<ion-header>
  <ion-toolbar>
    <ion-title>Filter</ion-title>
    <ion-buttons slot="end">
      <img class="pointer" src="assets/icon/common/X.svg" (click)="cancel()" />
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <ion-row style="height: 100%">
    <ion-col
      class="left-nav"
      size="auto"
      style="height: 100%; overflow-y: scroll; border-right: 1px solid #cbcbcd; padding: 10px 10px 10px 0"
    >
      <div style="width: 180px">
        <ion-button
          style="width: 100%; position: relative"
          *ngFor="let group of filterModel.groups; let filterIndex = index; trackBy: trackByFn"
          [color]="activeFilterIdx === filterIndex ? 'primary' : 'none'"
          (click)="activeFilter(filterIndex)"
        >
          <ng-container *ngIf="group.type === 'SELECT_FILTER'">
            <span>{{ group.displayName }}</span>
            <div *ngIf="group.selectedValues.length" class="filter-select-count">
              {{ group.selectedValues.length }}
            </div>
          </ng-container>
          <ng-container *ngIf="group.type === 'SINGLE_SELECT_FILTER'">
            <span>{{ group.displayName }}</span>
          </ng-container>
          <ng-container *ngIf="group.type === 'DATE_FILTER'">
            <span>Date Filter</span>
          </ng-container>
          <ng-container *ngIf="group.type === 'SEARCH_FILTER'">
            <span>Search Filter</span>
          </ng-container>
          <ng-container *ngIf="group.type === 'DURATION_FILTER'">
            <span>{{ group.displayName }}</span>
          </ng-container>
          <ng-container *ngIf="group.type === 'ORG_HIERARCHY_FILTER'">
            <span>{{ group.displayName }}</span>
            <div *ngIf="group.leafNodesSelected" class="filter-select-count">
              {{ group.leafNodesSelected }}
            </div>
          </ng-container>
        </ion-button>
      </div>
    </ion-col>
    <ion-col style="height: 100%; overflow-y: scroll">
      <ng-container *ngFor="let item of [filterModel.groups[activeFilterIdx]]; trackBy: trackByFn">
        <ng-container *ngIf="item.type === 'SELECT_FILTER'">
          <monorepo-multi-select-popover-depr
            [filterKey]="item.key"
            [displayName]="item.displayName"
            [popoverInfo]="item.items"
            [searchWithApi]="item.searchWithApi"
            [selectedFilters]="filterModel.selectedFilters"
            [popoverRenderOptionType]="'TABS'"
            (onModelChange)="updatedModel($event, activeFilterIdx)"
          >
          </monorepo-multi-select-popover-depr>
        </ng-container>
        <ng-container *ngIf="item.type === 'SINGLE_SELECT_FILTER'">
          <!-- <monorepo-inline-single-select
              [inlineSingleSelectInput]="filterGroup"
              (selectedItemEvent)="updateByGroupInfo($event)"
            ></monorepo-inline-single-select> -->
        </ng-container>
        <ng-container *ngIf="item.type === 'DATE_FILTER'">
          <!-- <ui-select [filterModel]="filterGroup" (selectedFilterEvent)="updateByGroupInfo($event)"></ui-select> -->
        </ng-container>
        <ng-container *ngIf="item.type === 'SEARCH_FILTER'">
          <!-- <ui-search-filter
              [filterModel]="filterGroup"
              (searchQueryEvent)="updateByGroupInfo($event)"
            ></ui-search-filter> -->
        </ng-container>
        <ng-container *ngIf="item.type === 'DURATION_FILTER'">
          <monorepo-duration-picker
            [itemsInfo]="item.items"
            dateType="string"
            [selectedDateFilter]="item.selectedValues[0]"
            renderType="INLINE"
            (onModelChange)="updatedModel($event, activeFilterIdx)"
          >
          </monorepo-duration-picker>
        </ng-container>
        <ng-container *ngIf="item.type === 'ORG_HIERARCHY_FILTER'">
          <monorepo-org-heirarchy
            [orgTree]="item.hierarchy"
            [filteredOrgTree]="item.filteredOrgTree"
            [minimizeAllNodes]="false"
            [showDesc]="false"
            [isPopover]="false"
            [showClear]="false"
            [showApply]="false"
            (orgHeirarchySelectionEmitter)="orgHeirarchySelectionEmitter($event, activeFilterIdx)"
          >
          </monorepo-org-heirarchy>
        </ng-container>
      </ng-container>
    </ion-col>
  </ion-row>
</ion-content>
<ion-footer class="footer">
  <ion-toolbar>
    <ion-button slot="start" fill="clear" (click)="clearFilter()" [disabled]="!filterModel.hasSelectedFilters">
      Clear All
    </ion-button>
    <ion-button slot="end" (click)="confirm()">Apply</ion-button>
  </ion-toolbar>
</ion-footer>
